import { useContext } from 'react'
import { createPortal } from 'react-dom'
import { useArticleContext } from '../_core'
import CategoryChoice from './CategoryChoice'
import Callout from '@components/DesignSystem/Callout'
import { useTranslation } from '@i18n'
import { EditorPageContext } from '../_core/EditorPageContext'
import { styled, theme } from 'twin.macro'

const CATEGORY_CALLOUT_ROOT_ID = 'categoryCalloutRoot'

export const CategoryCalloutRoot = styled.div.attrs({
  id: CATEGORY_CALLOUT_ROOT_ID,
})`
  /* -4px 是為了抵銷 CategoryChoice 的 padding-margin */
  margin: -4px 16px 20px;
  @media (min-width: ${theme`screens.md`}) {
    margin: 8px 0 0;
  }

  &:empty {
    margin: 0;
  }
`

function CategoryContainer() {
  const { t } = useTranslation('editor')
  const {
    articleState: {
      publish: { timestamp, warnings, action },
    },
  } = useArticleContext()

  const { categories } = useContext(EditorPageContext)

  return (
    <>
      <CategoryChoice categories={categories} />
      {warnings?.categoryRequired &&
        createPortal(
          <Callout
            key={timestamp}
            title={t('warnings.categoryRequired.title')}
            message={t(`warnings.categoryRequired.message.${action}`)}
          />,
          document.querySelector(`#${CATEGORY_CALLOUT_ROOT_ID}`),
        )}
    </>
  )
}

export default CategoryContainer
